'use client'

import { Box, Paper, useMediaQuery } from '@mui/material'
import { DeviceContext, getDevice } from 'app/_hooks'
import { usePathname } from 'next/navigation'
import { FC, ReactNode, useMemo } from 'react'
import { AppBottomNavigation } from '~/components/AppBottomNavigation'
import theme from '~/libs/mui/theme'

type AuthLayoutProps = {
  children?: ReactNode
}

const AuthLayout = ({ children }: { children: ReactNode }) => {
  return (
    <DeviceContext.Provider
      value={typeof navigator === 'undefined' ? 'PC' : getDevice(navigator.userAgent)}
    >
      {/** TODO: 一旦、AuthLayoutにしているが未ログイン対応が入るので将来的には別のレイアウトに吐き出される */}
      <_AuthLayout>{children}</_AuthLayout>
    </DeviceContext.Provider>
  )
}

const _AuthLayout: FC<AuthLayoutProps> = ({ children }) => {  

  return (
    <Box>
      {children}

      <Footer />

      {/* others */}      
    </Box>
  )
}

const Footer: FC = () => {
  const isSm = useMediaQuery(theme.breakpoints.up('sm'))

  const pathname = usePathname()
  const showMobileFooter = useMemo(() => {
    return !pathname?.startsWith('/videos/')
  }, [pathname])

  return isSm ? (
    // <Box bottom={0} left={0} right={0}>
    //   <AppFooter />
    // </Box>
    null
  ) : showMobileFooter ? (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
      <AppBottomNavigation />
    </Paper>
  ) : null
}

export default AuthLayout
